import {connect} from 'react-redux';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {getTimeFormat} from '../../../store/data/preferences/preferencesSelectors';
import {InlineEditingDateTimePicker} from './inlineEditingDateTimePicker';

/*
 * Props.
 */

interface InlineEditingDateTimePickerContainerProps {
  value: string;
  onEdit: HandlerOf<string>;
  onEditSave: HandlerOf<string>;
  selectedValue: string;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InlineEditingDateTimePickerContainerProps>()(() => ({
  timeFormat: getTimeFormat,
}));

export const InlineEditingDateTimePickerContainer = connect(mapStateToProps)(InlineEditingDateTimePicker);
